module.exports = __webpack_public_path__ + "img/logo-small.d693f01f.png";